import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationVariantProps } from '../types';

import IconButton from '../../Buttons/IconButton';

const DefaultS = forwardRef<HTMLDivElement, PaginationVariantProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      dark,
      white,
      className,
      ...other
    },
    ref,
  ) => (
    <div ref={ref} className={cn('flex items-center', className)} {...other}>
      <IconButton
        arrow="left"
        xs
        darkMode={dark}
        white={white}
        disabled={currentPage <= 1}
        onClick={onPrev}
      />
      <p
        className={`w-80 mx-16 font-gil text-14 leading-18 tracking-4 flex items-center justify-center text-center ${
          dark ? 'text-white' : 'text-base-main'
        }`}
      >
        <span className="font-bold mr-4">{`${
          currentPage.toString().length < 2 ? 0 : ''
        }${currentPage}`}</span>
        {`/ ${totalPages.toString().length < 2 ? 0 : ''}${totalPages}`}
      </p>
      <IconButton
        arrow="right"
        xs
        darkMode={dark}
        white={white}
        disabled={currentPage >= totalPages}
        onClick={onNext}
      />
    </div>
  ),
);

export default DefaultS;
